import * as React from "react"

import { cn } from "@/lib/utils"
import {
  shouldAutoCapitalizeInput,
  withFirstLetterCapitalized,
} from "@/lib/autoCapitalize"

/**
 * Global auto-capitalisation is wired in at this primitive so every form
 * in Le Desk (Tâches, Documents, Pointage, Paramètres, …) gets it for
 * free. Skipped for email/password/number/url/date/time inputs. Opt-out
 * per-field with `data-no-capitalize` (used by search bars).
 */
const Input = React.forwardRef(({ className, type, onChange, ...props }, ref) => {
  const handleChange = shouldAutoCapitalizeInput(type, props)
    ? withFirstLetterCapitalized(onChange)
    : onChange;

  return (
    <input
      type={type}
      onChange={handleChange}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
